import type { ReactNode } from 'react'

export const Choice = ({
  type = 'radio',
  name,
  value,
  checked,
  onChange,
  label,
  description,
  disabled,
}: {
  type?: 'radio' | 'checkbox'
  name: string
  value: string
  checked: boolean
  onChange: (value: string) => void
  label: ReactNode
  description?: ReactNode
  disabled?: boolean
}) => (
  <label className="choice">
    <input
      className="choice-input"
      type={type}
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={() => onChange(value)}
    />
    <span className="choice-text">
      <span className="choice-label">{label}</span>
      {description === undefined ? null : <span className="choice-description">{description}</span>}
    </span>
  </label>
)
